define([], function () {
    "use strict";

    var cookieOp = {};

    cookieOp.addCookie = function (name, value, expiresMillis, path) {
        var cookieStr;
        if (this.hasCookie(name))
        {
            this.delCookie(name);
        }
        if (value)
        {
            cookieStr = name + "=" + encodeURIComponent(value);
        }
        var expiresTime = Number(expiresMillis);
        if (!isNaN(expiresTime) && expiresTime > 0)
        {
            var date = new Date();
            date.setTime(date.getTime() + expiresTime);
            if (path) {
                cookieStr += ";path="+path+"; expires="+date.toUTCString();
            } else {
                cookieStr += "; expires="+date.toUTCString();
            }
        }
        if (value)
        {
            document.cookie = cookieStr + ";secure";
        }
    };

    cookieOp.getCookie = function (name) {
        var cookieStr = document.cookie;
        var cookieArray = cookieStr.split(";");

        for (var i = 0; i < cookieArray.length; i++)
        {
            var arr=$.trim(cookieArray[i]).split("=");
            if (arr[0] === name)
            {
                return decodeURIComponent(arr[1]);
            }
        }
        return undefined;
    };

    cookieOp.delCookie = function (name) {
        var date=new Date();
        date.setTime(date.getTime() - 10000);
        //设置cookie的过期时间为过去的某个时间
        document.cookie = name + "=v; expires="+date.toUTCString();
    };

    cookieOp.hasCookie = function (name) {
        return this.getCookie(name) != undefined;
    };

    cookieOp.setCookie = function (name, value, expiresMillis) {
        this.addCookie(name, value, expiresMillis);
    };

    cookieOp.DEFAULT_EXPIRES_TIME = 30 * 24 * 3600 * 1000; //30天

    return cookieOp;
});


// WEBPACK FOOTER //
// ./public/base/utils/cookie.js